export default __webpack_public_path__ + "static/media/companyimg3.293df1d1.jpeg";